const Certificates = () => {
  return (
    <div className="flex flex-wrap items-center justify-start gap-2">
     
      <a  className="enamad flex h-16 w-16 items-center justify-center rounded-lg border border-slate-200 bg-white" referrerPolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=748018&Code=Zz8WOPHvRBey78nsuFc2Zx6IE1KPphbA'>
        <img className="w-full h-full object-contain rounded-lg border border-dashed border-border-secondary"
        referrerPolicy='origin'
        src='https://trustseal.enamad.ir/logo.aspx?id=748018&Code=Zz8WOPHvRBey78nsuFc2Zx6IE1KPphbA' alt='' />
      </a>   
      <a
        href="https://www.shahr-bank.ir/"
        className="flex h-16 w-16 items-center justify-center rounded-lg border border-slate-200 bg-white"
        aria-label="بانک شهر"
      >
        <img
          src="/assets/images/Svg/Licences/BankShahr.svg"
          alt="بانک شهر"
          className="h-12 w-12 object-contain"
        />
      </a>
    </div>
  )
}

export default Certificates
